import { render, staticRenderFns } from "./person-left-tab.vue?vue&type=template&id=2a9425c4&scoped=true"
import script from "./person-left-tab.vue?vue&type=script&lang=js"
export * from "./person-left-tab.vue?vue&type=script&lang=js"
import style0 from "./person-left-tab.vue?vue&type=style&index=0&id=2a9425c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9425c4",
  null
  
)

export default component.exports